export const en = {
    countries: 'todo',
    'desktop-view': 'Desktop',
    districts: 'todo',
    ltv: 'LTV',
    'mobile-view': 'Mobile',
    'new-tab-view': 'todo',
    regions: 'todo'
};
